import {
  useEditApiTokenFlow,
  useEditApiTokenForm,
  useEditApiTokenFormData,
  useEditApiTokenModal,
} from '../model';
import {
  ApiErrorText,
  Loader,
  ModalComponentWrapper,
} from '@/shared/components';
import { useTranslation } from 'react-i18next';
import type { ApiToken } from '@/entities/api-token';
import { EditApiTokenForm } from './EditApiTokenForm';

type Props = {
  apiToken: ApiToken;
  accountNumber: string;
  onBack: () => void;
};

export const EditApiTokenModal = ({
  apiToken,
  accountNumber,
  onBack,
}: Props) => {
  const { t } = useTranslation();

  const { form } = useEditApiTokenForm({ apiToken });

  const { openEditApiTokenModal } = useEditApiTokenModal();

  const { updateApiToken, isPending } = useEditApiTokenFlow({
    form,
    apiTokenId: apiToken.webapiTokenid,
    accountNumber,
    onBackToEditApiTokenModal: () =>
      openEditApiTokenModal({ apiToken, accountNumber, onBack }),
    onBackToApiTokensModal: () => onBack(),
  });

  const { accessTypes, authenticationTypes, isLoading, error } =
    useEditApiTokenFormData();

  return (
    <ModalComponentWrapper
      title={t('webApiTokens.editing.title')}
      onBack={onBack}>
      {isLoading && <Loader />}

      {error && <ApiErrorText error={error} size="small" />}

      {!isLoading && !error && (
        <EditApiTokenForm
          form={form}
          updateApiToken={updateApiToken}
          isPending={isPending}
          accessTypes={accessTypes}
          authenticationTypes={authenticationTypes}
        />
      )}
    </ModalComponentWrapper>
  );
};
